import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import parseNumber from "../../../../utils/parseCalculate";
import { useLiveDevice } from "../../../../hooks/useLiveDeviceData";
import { BatteryIcon, WifiIcon } from "../../../icons/StatusIcons";

const ListItemWrap = (props) => {
  const endDate = "";
  const { data: liveData } = useLiveDevice(props.deviceId);
  const deviceDetail = liveData || props.deviceDetail;
  const totalFlow = deviceDetail
    ? parseNumber(
        props.deviceType === "flow" ? deviceDetail.flowrate : deviceDetail.level
      )
    : "--";

  return (
    <div className="list-card">
      <div className="basic-info">
        <Link to={props.link}>
          {" "}
          <h3 className="list-name">{props.name}</h3>
        </Link>
        {props.company && <p className="company-name">{props.company}</p>}
      </div>

      <div className="middle-info">
        {props.deviceType && (
          <>
            <h4 className="flow-data">{totalFlow}</h4>
            <p className="unit">
              {props.deviceType === "flow" 
                ? (props.flowUnit || "litre/min") 
                : (props.levelUnit || "litres")}
            </p>
            <p className="flow-name">
              {props.deviceType === "flow" ? "Current Flow" : "Current Level"}
            </p>
          </>
        )}

        {!props.deviceType && !props.assignee && (
          <p className="empty-msg">Device Not Assigned</p>
        )}

        {props.assignee > 0 && (
          <>
            <h4 className="flow-data">{props.assignee}</h4>
            <p className="flow-name">Assigned Devices</p>
          </>
        )}
      </div>

      <div className="other-info d-flex align-items-center">
        <div className="date-wrap">
          {props.date && (
            <p className="date-info">
              Date Added: <span>{props.date}</span>
            </p>
          )}

          {props.id &&
            (endDate !== "" ? (
              <p className="date-info">
                Subscription End:{" "}
                <span>
                  {new Date(endDate).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                </span>
              </p>
            ) : (
              <p className="date-info">
                Subscription End: <span>---</span>
              </p>
            ))}
        </div>

        <div className="action-btn">
          {props.deviceCard && (
            <WifiIcon connected={deviceDetail?.network_active === 1} />
          )}
          {props.deviceCard && (
            <Tooltip title={deviceDetail?.battery === 1 ? "Power On" : "Power Off"}>
              <BatteryIcon on={deviceDetail?.battery === 1} />
            </Tooltip>
          )}
          {!props.hideAction && (
            <Dropdown>
              <Dropdown.Toggle className="dropdown-action-btn">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.9214 11.6157C12.6812 11.6157 11.6665 12.6304 11.6665 13.8706C11.6665 15.1108 12.6812 16.1255 13.9214 16.1255C15.1616 16.1255 16.1763 15.1108 16.1763 13.8706C16.1763 12.6304 15.1616 11.6157 13.9214 11.6157ZM13.9214 8.2334C15.1616 8.2334 16.1763 7.2187 16.1763 5.97852C16.1763 4.73833 15.1616 3.72363 13.9214 3.72363C12.6812 3.72363 11.6665 4.73833 11.6665 5.97852C11.6665 7.2187 12.6812 8.2334 13.9214 8.2334ZM13.9214 19.5078C12.6812 19.5078 11.6665 20.5225 11.6665 21.7627C11.6665 23.0029 12.6812 24.0176 13.9214 24.0176C15.1616 24.0176 16.1763 23.0029 16.1763 21.7627C16.1763 20.5225 15.1616 19.5078 13.9214 19.5078Z"
                    fill="black"
                  />
                </svg>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <button
                  className="dropdown-btn px-3 py-2 text-start w-100"
                  onClick={props.onUpdate}
                >
                  Edit
                </button>
                <button
                  className="dropdown-btn px-3 py-2 text-start w-100"
                  onClick={props.onDelete}
                >
                  Delete
                </button>

                {props.deviceCard && (
                  <>
                    {!props.isCustomer ? (
                      <button
                        className="dropdown-btn px-3 py-2 text-start w-100"
                        onClick={props.assignCustomer}
                      >
                        Assign Customer
                      </button>
                    ) : (
                      <button
                        className="dropdown-btn px-3 py-2 text-start w-100"
                        onClick={props.unassignCustomer}
                      >
                        Unassign Customer
                      </button>
                    )}

                    {!props.hideDealer && (
                      <>
                        {!props.isDealer ? (
                          <button
                            className="dropdown-btn px-3 py-2 text-start w-100"
                            onClick={props.assignDealer}
                          >
                            Assign Dealer
                          </button>
                        ) : (
                          <button
                            className="dropdown-btn px-3 py-2 text-start w-100"
                            onClick={props.unassignDealer}
                          >
                            Unassign Dealer
                          </button>
                        )}
                      </>
                    )}
                  </>
                )}
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListItemWrap;
